<template>
  <div class="mr-2">
    <el-card :body-style="{ padding: '0px', width: `${defaultWidth}px` }">
      <el-avatar
        v-if="data?.banner_media?.url"
        shape="square"
        :size="defaultWidth"
        :src="imgProxy(data?.banner_media?.url, rs=`fill:${defaultWidth}:${defaultWidth}:1`)"
        :alt="data?.title"
      />
      <el-avatar 
        v-else shape="square" 
        :size="defaultWidth"
        style="margin-bottom: 6px"
        > 
        {{ data?.title }} 
      </el-avatar>

      <div class="p-2">
        <div class="text-center text-primary mb-2 text-truncate-2">{{ data?.title }}</div>
        <div class="bottom clearfix">
          <el-button 
            v-if="!isProcessing"
            :type="isEnded ? 'info' : 'success'" 
            disabled
            class="btn-block" 
            >
            {{ isEnded ? '已過期' : '已領取'}}
          </el-button>
          <el-button 
            v-else
            type="primary" 
            class="btn-block" 
            @click="createCode"
            >
            立即領取
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { dataTranslations as dt, dateFormat, imgProxy } from "../../utils"
import RatioImage from '../RatioImage.vue'

const props = defineProps({
  data: { type: Object, required: true },
  userCodes: { type: Array, default: () => [] },
})
const emit = defineEmits(['ok'])

const defaultWidth = 250
const isEnded = computed(() => !!props.data?.ended_at ? dayjs(props.data?.ended_at) < dayjs() : false)
const isPicked = computed(() => props.userCodes.includes(props.data?.id))
const isProcessing = computed(() => !isEnded.value && !isPicked.value)
const createCode = () => {
  emit("ok", props.data)
}
</script>